module.exports = __webpack_public_path__ + "img/66.48fe8c05.png";